<script setup lang="ts">
import BaseError from '@/components/base/BaseError.vue'

interface Props {
  /** Field label for accessibility */
  label?: string | null
  /** Array of error messages to display */
  errors?: string[] | null
}

const { label = null, errors = [] } = defineProps<Props>()

defineOptions({
  name: 'BaseErrors'
})
</script>

<template>
  <div v-show="errors?.length" class="error-container">
    <BaseError v-for="(error, i) in errors" :key="i" :label :error>
      {{ error }}
    </BaseError>
  </div>
</template>

<style lang="scss" scoped>
@reference '../../styles/main.css';

.error-container {
  @apply flex flex-col gap-1;
}
</style>
